<template>
    <v-container class="pa-0">
        <!--!isMobile-->
        <v-navigation-drawer
            v-if="!isMobile && !isTablet"
            class="menu-drawer desktop-menu-drawer"
            :class="{ 'menu-drawer-not-expended': !isMenuExpanded }"
            v-model="isMenuDrawerOpen"
            :right="$vuetify.rtl"
            :left="$vuetify.ltr"
            app
            permanent
        >
            <!--header-->
            <v-container
                class="header pa-0"
            >
                <v-container
                    class="flex-logo pa-2"
                    @click="menuToggle"
                >
                    <img
                        :src="userInfo?.init?.logo?.link || require('@/assets/logo-abr-iron.png')"
                    />
                    <v-container
                        v-if="isMenuExpanded"
                        class="pa-0"
                    >
                        <v-card-text class="text-body-2 pa-0">{{ userInfo?.init?.abrName }}</v-card-text>
                        <!-- <v-card-text class="text-caption pa-0" style="color: #5d5757d1;">ارز سیستم: {{ userInfo?.init?.currency?.name }}</v-card-text> -->
                        <v-card-text class="text-caption pa-0" style="color: #5d5757d1;">ارز سیستم: {{ $store.state.currency.name }}</v-card-text>
                    </v-container>
                </v-container>
                <v-container
                    class="flex-search py-0 px-2"
                >
                    <v-autocomplete
                        v-if="isMenuExpanded"
                        class="flex-fill"
                        :label="$t('search-in-menu')"
                        append-icon=""
                        clear-icon="mdi-close"
                        outlined
                        dense
                        clearable
                        v-model="search"
                        :items="childTitles"
                        item-text="title"
                        return-object
                        @input="selectChild"
                    >
                    <template v-slot:item="{ item }">
                        <v-hover v-slot:default="{ hover }">
                            <v-container class="d-flex justify-space-between pa-0">
                                <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ item.title }}</v-card-text>
                                <v-icon
                                v-if="hover"
                                @click.stop.prevent="createShortcut(item)"
                                size="15"
                                class="text-disable secondary--text"
                                >
                                mdi-pin-outline
                                </v-icon>
                            </v-container>
                        </v-hover>
                    </template>
                    </v-autocomplete>
                    <v-container
                        v-if="isMenuExpanded"
                        class="wrapper-add-menu pa-0"
                        style="width: auto;"
                    >
                        <v-menu
                            v-model="isAddMenuOpened"
                            top
                            attach=".wrapper-add-menu"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    outlined
                                    custom
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    style="height: 32px !important;padding: 5px !important;"
                                >
                                    <v-icon size="20">mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-container
                                class="add-menu-hover"
                            >
                                <v-container
                                    class="c-menu"
                                >
                                    <router-link
                                        :to="{ 'name': item.to }"
                                        v-for="(item, index) in addMenu"
                                        :key="index"
                                    >
                                        <v-container
                                            class="text-caption route-menu-add py-0 px-3"
                                            v-if="resolvePermissions(item.to)"
                                        >
                                            {{ $t(item.title) }}
                                        </v-container>
                                    </router-link>
                                </v-container>
                            </v-container>
                        </v-menu>
                    </v-container>
                    <v-container
                        v-else
                        class="container-add-menu pa-0"
                        style="width: auto;"
                    >
                        <v-menu
                            v-model="isAddMenuOpened"
                            open-on-hover
                            top
                            attach=".container-add-menu"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    outlined
                                    custom
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    style="height: 28px !important;padding: 5px !important;"
                                >
                                    <v-icon size="20">mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-container
                                class="add-menu-hover"
                            >
                                <v-container
                                    class="c-menu"
                                >
                                    <router-link
                                        :to="{ 'name': item.to }"
                                        v-for="(item, index) in addMenu"
                                        :key="index"
                                    >
                                        <v-container
                                            class="text-caption route-menu-add py-0 px-3"
                                            v-if="resolvePermissions(item.to)"
                                        >
                                            {{ $t(item.title) }}
                                        </v-container>
                                    </router-link>
                                </v-container>
                            </v-container>
                        </v-menu>
                    </v-container>
                </v-container>
            </v-container>
            <!--body-->
            <v-container
                class="body pa-0"
            >
                <v-expansion-panels
                    focusable
                    class="px-2"
                    v-model="expandedIndex"
                >
                    <v-expansion-panel
                        v-if="menuItem != undefined && menuItem.length > 0 && resolveShowMenu(item)"
                        v-for="(item, index) in computedItems"
                        :key="index"
                        :value="expandedIndex == index"
                        :class="{'not-expanded px-0': !isMenuExpanded}"
                    >
                        <v-expansion-panel-header
                            :class="{'pa-0': !isMenuExpanded, 'exp-header-no-child': item.children == undefined}"
                        >
                            <!--isMenuExpanded-->
                            <v-container
                                class="pa-0"
                                v-if="isMenuExpanded"
                            >
                                <!--has child-->
                                <v-container
                                    v-if="item.children != undefined && item.children.length > 0"
                                    class="flex-nav-expanded pa-0"
                                    @click="selectMenuChild"
                                >
                                    <v-divider
                                        class="active"
                                        :class="{ 'active-parent': isMenuExpanded && resolveHasActiveChild(item) }"
                                    />
                                    <v-icon
                                        :color="resolveHasActiveChild(item) ? 'primary' : 'default'"
                                    >
                                        {{ item.icon }}
                                    </v-icon>
                                    <v-card-text
                                        class="text-caption pa-0 mt-1"
                                        :class="{ 'text-center text-caption': !isMenuExpanded }"
                                        :style="{ 'color': resolveHasActiveChild(item) ? '#0066ff' : 'inherit' }"
                                    >
                                        {{ $t(item.title) }}
                                    </v-card-text>
                                </v-container>
                                <!--doesn't have child-->
                                <v-container
                                    v-else
                                    class="nav-item-without-child pa-0"
                                    @click="selectMenuChild"
                                >
                                    <router-link
                                        :to="{ 'name': item.to, 'params': item.params }"
                                        :style="{'color': $route.path === $router.resolve({ name: item.to }).href ? '#0066ff' : 'inherit'}"
                                    >
                                        <v-container
                                            :class="{ 'flex-nav-expanded': isMenuExpanded, 'flex-nav': !isMenuExpanded }"
                                            class="pa-0"
                                        >
                                            <v-divider
                                                class="active"
                                                :class="{ 'active-parent': isMenuExpanded && $route.path === $router.resolve({ name: item.to }).href }"
                                            />
                                            <v-icon
                                                :color="$route.path === $router.resolve({ name: item.to }).href ? 'primary' : 'default'"
                                            >
                                                {{ item.icon }}
                                            </v-icon>
                                            <v-card-text
                                                class="text-caption pa-0 mt-1"
                                                :class="{ 'text-center text-caption': !isMenuExpanded }"
                                                :style="{ 'color': $route.path === $router.resolve({ name: item.to }).href ? '#0066ff' : 'inherit' }"
                                            >
                                                {{ $t(item.title) }}
                                            </v-card-text>
                                        </v-container>
                                    </router-link>
                                </v-container>
                            </v-container>
                            <!-- !isMenuExpanded -->
                            <v-container
                                class="pa-0"
                                v-if="!isMenuExpanded"
                            >
                                <v-menu
                                    open-on-hover
                                    bottom
                                    offset-x
                                    open-delay="300"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <!--has-child-->
                                        <v-container
                                            v-if="item.children != undefined && item.children.length > 0"
                                            class="pa-0 flex-nav"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                :color="resolveHasActiveChild(item) ? 'primary' : 'default'"
                                            >
                                                {{ item.icon }}
                                            </v-icon>
                                            <v-card-text
                                                class="text-caption text-caption-menu pa-0 mt-1"
                                                :class="{ 'text-center text-caption': !isMenuExpanded }"
                                                :style="{ 'color': resolveHasActiveChild(item) ? '#0066ff' : 'inherit' }"
                                            >
                                                {{ $t(item.title) }}
                                            </v-card-text>
                                        </v-container>
                                        <!--doesn't have child-->
                                        <v-container
                                            v-else
                                            class="nav-item-without-child pa-0"
                                        >
                                            <router-link
                                                :to="{ 'name': item.to, 'params': item.params }"
                                                :style="{'color': $route.path === $router.resolve({ name: item.to }).href ? '#0066ff' : 'inherit'}"
                                            >
                                                <v-container
                                                    :class="{ 'flex-nav-expanded': isMenuExpanded, 'flex-nav': !isMenuExpanded }"
                                                    class="pa-0"
                                                >
                                                    <v-divider
                                                        v-if="isMenuExpanded && $route.path === $router.resolve({ name: item.to }).href"
                                                        class="active"
                                                    />
                                                    <v-icon
                                                        :color="$route.path === $router.resolve({ name: item.to }).href ? 'primary' : 'default'"
                                                    >
                                                        {{ item.icon }}
                                                    </v-icon>
                                                    <v-card-text
                                                        class="text-caption text-caption-menu pa-0 mt-1"
                                                        :class="{ 'text-center text-caption': !isMenuExpanded }"
                                                        :style="{ 'color': $route.path === $router.resolve({ name: item.to }).href ? '#0066ff' : 'inherit' }"
                                                    >
                                                        {{ $t(item.title) }}
                                                    </v-card-text>
                                                </v-container>
                                            </router-link>
                                        </v-container>
                                    </template>
                                    <v-container
                                        class="wrapper-v-menu"
                                    >
                                        <v-container
                                            v-for="(child, index) in item.children"
                                            :key="index"
                                            class="custom-router-link"
                                            :class="{ 'router-link-active': $route.path === $router.resolve({ name: child.to }).href }"
                                            v-if="child.show && child.title != 'divider'"
                                            @mouseover="onChildHover(child, index)"
                                            @mouseleave="onChildLeave"
                                        >
                                            <router-link
                                                :to="{ 'name': child.to, 'params': child.params }"
                                            >
                                                <v-container
                                                    class="wrapper-router"
                                                >
                                                    <v-divider class="active" />
                                                    <!--<v-icon>{{ child.icon }}</v-icon>-->
                                                    <v-card-text
                                                        class="text-caption pa-0 mt-1"
                                                    >
                                                    {{ (hoveredChild != null && hoveredChild == child.title && $t(child.title).length > 17) ? $t(child.title).substring(0,17) + '...' : $t(child.title) }}
                                                    </v-card-text>
                                                </v-container>
                                            </router-link>
                                            <v-icon
                                                size="16"
                                                class="ml-1 text--disabled"
                                                @click.stop.prevent="createShortcut(child)"
                                            >
                                                mdi-pin-outline
                                            </v-icon>
                                            <v-btn
                                                outlined
                                                custom
                                                color="primary"
                                                v-if="child.add"
                                                @click="routeAddNew(child.add)"
                                            >
                                                <v-icon size="12">mdi-plus</v-icon>
                                            </v-btn>
                                        </v-container>
                                    </v-container>
                                </v-menu>
                            </v-container>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                            v-if="item.children != undefined && item.children.length > 0 && isMenuExpanded"
                        >
                            <v-container
                                v-for="(child, index) in item.children"
                                :key="index"
                                class="custom-router-link"
                                :class="{ 'router-link-active': $route.path === $router.resolve({ name: child.to }).href }"
                                v-if="child.show && child.title != 'divider'"
                                @mouseover="onChildHover(child, index)"
                                @mouseleave="onChildLeave"
                                @click="selectMenuChild"
                            >
                                <router-link
                                    :to="{ 'name': child.to, 'params': child.params }"
                                >
                                    <v-container
                                        class="wrapper-router"
                                    >
                                        <v-divider class="active" />
                                        <!--<v-icon>{{ child.icon }}</v-icon>-->
                                        <v-card-text
                                            class="text-caption pa-0 mt-1"
                                        >
                                        {{ (hoveredChild != null && hoveredChild == child.title && $t(child.title).length > 17) ? $t(child.title).substring(0,17) + '...' : $t(child.title) }}
                                        </v-card-text>
                                    </v-container>
                                </router-link>
                                <v-icon
                                    size="16"
                                    class="ml-1 text--disabled"
                                    @click.stop.prevent="createShortcut(child)"
                                >
                                    mdi-pin-outline
                                </v-icon>
                                <v-btn
                                    outlined
                                    custom
                                    color="primary"
                                    v-if="child.add"
                                    @click="routeAddNew(child.add)"
                                >
                                    <v-icon size="12">mdi-plus</v-icon>
                                </v-btn>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
        </v-navigation-drawer>
        <!--isMobile-->
        <v-navigation-drawer
            v-if="isMobile || isTablet"
            class="menu-drawer mobile-menu-drawer"
            v-model="isMobileMenuDrawerOpen"
            app
            :right="$vuetify.rtl"
            :left="$vuetify.ltr"
        >
            <!-- header -->
            <v-container class="header pa-0">
                <v-container class="flex-logo px-2 pa-3" @click="menuToggle">
                    <img :src="userInfo?.init?.logo?.link || require('@/assets/logo-abr-iron.png')" />
                    <v-container class="pa-0">
                        <v-card-text class="text-caption pa-0">{{ userInfo?.init?.abrName }}</v-card-text>
                        <v-card-text class="text-caption pa-0" style="color: #5d5757d1;">
                            ارز سیستم: {{ userInfo?.init?.currency?.name }}
                        </v-card-text>
                    </v-container>
                    <v-icon @click="closeDrawer" size="18">mdi-close</v-icon>
                </v-container>
                <v-container class="flex-search py-0 px-2">
                    <v-autocomplete
                        class="flex-fill"
                        :label="$t('search-in-menu')"
                        append-icon=""
                        clear-icon="mdi-close"
                        outlined
                        dense
                        clearable
                        v-model="search"
                        :items="childTitles"
                        item-text="title"
                        return-object
                        @input="selectChild"
                    />
                    <v-container class="wrapper-add-menu pa-0" style="width: auto;">
                        <v-menu top attach=".wrapper-add-menu" v-model="isAddMenuOpened">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    outlined
                                    custom
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    style="height: 32px !important;padding: 5px !important;"
                                >
                                    <v-icon size="20">mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-container class="add-menu-hover">
                                <v-container class="c-menu">
                                    <router-link
                                        :to="{ 'name': item.to }"
                                        v-for="(item, index) in addMenu"
                                        :key="index"
                                    >
                                        <v-container
                                            class="text-caption route-menu-add py-0 px-3"
                                            v-if="resolvePermissions(item.to)"
                                        >
                                            {{ $t(item.title) }}
                                        </v-container>
                                    </router-link>
                                </v-container>
                            </v-container>
                        </v-menu>
                    </v-container>
                </v-container>
            </v-container>
            <!-- body -->
            <v-container class="body pa-0">
                <v-expansion-panels focusable class="px-2" v-model="expandedIndex">
                    <v-expansion-panel
                        v-if="menuItem != undefined && menuItem.length > 0 && resolveShowMenu(item)"
                        v-for="(item, index) in computedItems"
                        :key="index"
                        :value="expandedIndex == index"
                    >
                        <v-expansion-panel-header
                            :class="{ 'exp-header-no-child': item.children == undefined }"
                        >
                            <!-- isMenuExpanded -->
                            <v-container class="pa-0">
                                <!-- has child -->
                                <v-container
                                    v-if="item.children != undefined && item.children.length > 0"
                                    class="flex-nav-expanded pa-0"
                                >
                                    <v-divider
                                        class="active"
                                        :class="{ 'active-parent': resolveHasActiveChild(item) }"
                                    />
                                    <v-icon :color="resolveHasActiveChild(item) ? 'primary' : 'default'">
                                        {{ item.icon }}
                                    </v-icon>
                                    <v-card-text
                                        class="text-caption pa-0 mt-1"
                                        :style="{ 'color': resolveHasActiveChild(item) ? '#0066ff' : 'inherit' }"
                                    >
                                        {{ $t(item.title) }}
                                    </v-card-text>
                                </v-container>
                                <!-- doesn't have child -->
                                <v-container v-else class="nav-item-without-child pa-0">
                                    <router-link
                                        :to="{ 'name': item.to, 'params': item.params }"
                                        :style="{ 'color': $route.path === $router.resolve({ name: item.to }).href ? '#0066ff' : 'inherit' }"
                                    >
                                        <v-container class='flex-nav-expanded pa-0'>
                                            <v-divider
                                                class="active"
                                                :class="{ 'active-parent': $route.path === $router.resolve({ name: item.to }).href }"
                                            />
                                            <v-icon
                                                :color="$route.path === $router.resolve({ name: item.to }).href ? 'primary' : 'default'"
                                            >
                                                {{ item.icon }}
                                            </v-icon>
                                            <v-card-text
                                                class="text-caption pa-0 mt-1"
                                                :style="{ 'color': $route.path === $router.resolve({ name: item.to }).href ? '#0066ff' : 'inherit' }"
                                            >
                                                {{ $t(item.title) }}
                                            </v-card-text>
                                        </v-container>
                                    </router-link>
                                </v-container>
                            </v-container>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                            v-if="item.children != undefined && item.children.length > 0"
                        >
                            <v-container
                                v-for="(child, index) in item.children"
                                :key="index"
                                class="custom-router-link"
                                :class="{ 'router-link-active': $route.path === $router.resolve({ name: child.to }).href }"
                                v-if="child.show && child.title != 'divider'"
                                @mouseover="onChildHover(child, index)"
                                @mouseleave="onChildLeave"
                            >
                                <router-link :to="{ 'name': child.to, 'params': child.params }">
                                    <v-container class="wrapper-router">
                                        <v-divider class="active" />
                                        <v-card-text class="text-caption pa-0 mt-1">
                                            {{ (hoveredChild != null && hoveredChild == child.title && $t(child.title).length > 17) ? $t(child.title).substring(0,17) + '...' : $t(child.title) }}
                                        </v-card-text>
                                    </v-container>
                                </router-link>
                                <v-icon
                                    size="16"
                                    class="ml-1 text--disabled"
                                    @click.stop.prevent="createShortcut(child)"
                                >
                                    mdi-pin-outline
                                </v-icon>
                                <v-btn
                                    outlined
                                    custom
                                    color="primary"
                                    v-if="child.add"
                                    @click="routeAddNew(child.add)"
                                >
                                    <v-icon size="12">mdi-plus</v-icon>
                                </v-btn>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      isMenuDrawerOpen: true,
      search: null,
      expandedIndex: null,
      hoveredChild: null,
      mouseTimer: null,
      isTyping: false,
      isAddMenuHovered: false,
      addMenu: [
        {
          title: this.$t('person'),
          to: 'customer'
        },
        {
          title: this.$t('product'),
          to: 'Product'
        },
        {
          title: this.$t('service'),
          to: 'Service'
        },
        {
          title: this.$t('sales-invoice'),
          to: 'sell'
        },
        {
          title: this.$t('receive-cash'),
          to: 'recieve'
        }
      ],
      isAddMenuOpened: false,
      userInfo: null
    }
  },
  computed: {
    isMenuExpanded: {
      get () {
        return this.$store.state.isMenuExpanded
      },
      set (value) {
        this.$store.commit('SET_MENU_EXPANDED', value)
      }
    },
    menuItem () {
      if (this.$store.state.topMenu.length > 0) {
        return [...this.$store.state.topMenu, ...this.$store.state.menu]
      }
      return this.$store.state.menu
    },
    childTitles () {
      let children = []
      if (this.computedItems != undefined) {
        this.computedItems.forEach(menu => {
          if (menu.children && menu.children.length > 0) {
            children = children.concat(
              menu.children
                .filter(child => child.show || (child.add && child.add.show))
                .flatMap(child => {
                  const formattedChild = {
                    ...child,
                    title: this.$t(child.title)
                  }
                  const addChild = child.add && child.add.show
                    ? {
                      ...child.add,
                      title: this.$t(child.add.title)
                    }
                    : null
                  return addChild ? [formattedChild, addChild] : [formattedChild]
                })
            )
            /* console.log(children) */
          }
        })
        /* if (this.isTyping) {
          return children
        } */
        return children
      }
      return []
    },
    isMobileMenuDrawerOpen: {
      get () {
        return this.$store.state.isMobileMenuOpen
      },
      set (value) {
        this.$store.commit('SET_MOBILE_MENU', value)
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    checkAddMenuPermission () {
      for (var item in this.addMenu) {
        if (this.$store.state.permissions.includes(item.to)) {
          return true
        }
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    computedItems () {
      if (this.menuItem) {
        return this.menuItem.map(this.mapItem)
      }
    }
  },
  methods: {
    syncLayoutWidth () {
      if (this.isMobile || this.isTablet) {
        document.documentElement.style.setProperty('--dynamic-width', '0px')
        return
      }
      var dynamicWidth = this.isMenuExpanded ? '200px' : '70px'
      document.documentElement.style.setProperty('--dynamic-width', dynamicWidth)
    },
    menuToggle () {
      if (this.isMobile || this.isTablet) {
        this.syncLayoutWidth()
        return
      }
      if (this.isMenuExpanded) {
        this.isMenuExpanded = false
        if (this.expandedIndex != null) {
          this.expandedIndex = null
        }
      } else {
        this.isMenuExpanded = true
      }
      this.syncLayoutWidth()
    },
    resolveHasActiveChildOld (item) {
      if (item.children !== undefined && item.children.length > 0) {
        if (this.$route.path !== '/') {
          const activeChild = item.children.find(child => this.$router.resolve({ name: child.to }).href === this.$route.path)
          if (activeChild) {
            return true
          } else {
            return false
          }
        }
      }
    },
    resolveHasActiveChild (item) {
      if (item.children !== undefined && item.children.length > 0) {
        if (this.$route.path !== '/') {
          const activeChild = item.children.find(child =>
            child.show &&
            child.to !== 'divider' &&
            this.$router.resolve({ name: child.to }).href === this.$route.path
          )

          // const activeChild = item.children.find(child => this.$router.resolve({ name: child.to }).href === this.$route.path)
          if (activeChild) {
            return true
          } else {
            return false
          }
        }
      }
    },
    onChildHover (child, index) {
      if (this.mouseTimer) {
        clearTimeout(this.mouseTimer)
      }
      this.hoveredChild = child.title
    },
    onChildLeave () {
      this.mouseTimer = setTimeout(() => {
        this.hoveredChild = null
      }, 1)
    },
    routeAddNew (value) {
      this.$router.push({ name: value.to })
    },
    selectChild (selectedItem) {
      if (selectedItem && selectedItem.to != null) {
        this.$router.push({ name: selectedItem.to })
      }
    },
    /* isTypingHandler (e) {
      const ignoredKeys = ['Backspace', 'Shift', 'Alt']
      if (!ignoredKeys.includes(e.key)) {
        this.isTyping = true
      }
    }, */
    hoveAddMenu () {
      this.isAddMenuHovered = !this.isAddMenuHovered
    },
    closeDrawer () {
      this.isMobileMenuDrawerOpen = false
    },
    selectMenuChild () {
      if (this.search != null && this.$route.path !== this.search.to) {
        this.search = null
      }
    },
    resolvePermissions (value) {
      if (this.isAddMenuOpened && this.$store.state.permissions.includes(value)) {
        return true
      }
    },
    resolveShowMenu (item) {
      if (item !== undefined && item.children !== undefined) {
        return item.children.some(child => child.show === true)
      }
      if (item.children === undefined) {
        return true
      }
    },
    mapItem (item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title, { name: this.$store.state.studentLabel })
      }
    }
  },
  beforeMount () {
    this.getPermissions()
  },
  mounted () {
    this.syncLayoutWidth()
    this.userInfo = JSON.parse(localStorage.getItem('token'))
  },
  watch: {
    isTablet () {
      this.syncLayoutWidth()
    },
    isMobile () {
      this.syncLayoutWidth()
    },
    isMenuExpanded () {
      this.syncLayoutWidth()
    }
  }
}
</script>

<style scoped>
.menu-drawer.menu-drawer-not-expended {
    width: 70px !important;
    transform: scaleX(0.35);
}
.menu-drawer {
    width: 200px !important;
    transform: scaleX(1);
    transform-origin: right;
    transition: transform .5s ease-in-out;
    z-index: 4;
}
.menu-drawer.mobile-menu-drawer {
    transition: width .5s ease-in-out;
    width: 260px !important;
}
.menu-drawer.v-navigation-drawer ::v-deep .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}
.menu-drawer .header {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-shrink: 0;
}
.menu-drawer .body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}
.menu-drawer .header .flex-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    cursor: pointer;
}
.menu-drawer .header .flex-logo img {
    width: 33px;
}
.menu-drawer .header .flex-search {
    display: flex;
    justify-content: center;
    gap: .25rem;
}
/deep/ .wrapper-add-menu .v-menu__content {
    top: 50px !important;
    left: unset !important;
    right: 195px;
    width: 115px;
    max-width: unset !important;
}
/deep/ .wrapper-add-menu .v-menu__content .add-menu-hover {
    background-color: #fff;
    border-radius: 4px;
    padding: 4px !important;
}
/deep/ .wrapper-add-menu .add-menu-hover .c-menu {
    background-color: #f6f4f48f;
    border-radius: 2px;
    padding: 4px !important;
    display: flex;
    flex-direction: column;
    row-gap: .3rem;
}
/deep/ .wrapper-add-menu .c-menu .route-menu-add {
    display: flex;
    align-items: center;
    height: 30px;
}
/deep/ .wrapper-add-menu .c-menu .route-menu-add:hover {
    background-color: #fff;
    border-radius: 2px;
}

/deep/ .container-add-menu .v-menu__content {
    top: 50px !important;
    left: unset !important;
    right: 51px;
    width: 115px;
    max-width: unset !important;
}
/deep/ .container-add-menu .v-menu__content .add-menu-hover {
    background-color: #fff;
    border-radius: 4px;
    padding: 4px !important;
}
/deep/ .container-add-menu .add-menu-hover .c-menu {
    background-color: #f6f4f48f;
    border-radius: 2px;
    padding: 4px !important;
    display: flex;
    flex-direction: column;
    row-gap: .3rem;
}
/deep/ .container-add-menu .c-menu .route-menu-add {
    display: flex;
    align-items: center;
    height: 30px;
}
/deep/ .container-add-menu .c-menu .route-menu-add:hover {
    background-color: #fff;
    border-radius: 2px;
}
.menu-drawer .header .v-btn {
    padding: 6px !important;
}
.menu-drawer .body .v-expansion-panels {
    border-radius: 0;
    margin-top: 8px;
}
.menu-drawer.v-navigation-drawer {
    overflow: visible;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels {
    margin-top: 5px;
}
.menu-drawer .body .v-expansion-panel::before {
    box-shadow: none;
}
.menu-drawer .body .v-expansion-panel:not(:first-child)::after {
    border: none;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel {
    border: 1px solid transparent;
    border-radius: 4px;
    margin-top: 3px;
    padding: 2px 4px 3px 4px;
    cursor: pointer;
    transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels .v-expansion-panel {
    padding: 2px;
    position: relative;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel:hover {
    background-color: #f6f4f48f;
    border-color: silver;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header {
    padding: 0 5px;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header.exp-header-no-child ::v-deep .v-expansion-panel-header__icon,
.menu-drawer.mobile-menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header.exp-header-no-child ::v-deep .v-expansion-panel-header__icon {
    display: none !important;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header hr.active.v-divider {
    height: 20px;
    max-height: 20px;
    border-color: transparent;
    border-width: 1.5px;
    border-radius: 10px;
    flex: unset;
    margin-top: 2px;
    width: 0;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header hr.active.active-parent.v-divider {
    border-color: #0066ff;
}
.menu-drawer.v-navigation-drawer ::v-deep .v-expansion-panel-header__icon .v-icon {
    font-size: 15px !important;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header .v-icon {
    font-size: 22px !important;
}
.menu-drawer .body .v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile) > .v-expansion-panel--active {
    background-color: #f6f4f48f;
}
.menu-drawer .body .v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile) > .v-expansion-panel--active.not-expanded {
    background-color: #f6f4f48f;
    border-color: silver;
}
.menu-drawer .body .v-expansion-panel--active > .v-expansion-panel-header {
    border-radius: 2px;
    background-color: #fff;
}
.menu-drawer .body .v-expansion-panel--active.not-expanded > .v-expansion-panel-header {
    border-radius: 4px;
    background-color: transparent;
}
.menu-drawer .body .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover::before,
.menu-drawer .body .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active::before {
    opacity: 0;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .v-expansion-panel-header:before {
    background-color: transparent;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 31px;
}
.menu-drawer .body .v-expansion-panels ::v-deep .v-expansion-panel-content__wrap {
    padding: 4px 0 0 0;
    display: flex;
    flex-direction: column;
    row-gap: .3rem;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels ::v-deep .v-expansion-panel-content__wrap {
    margin: 5px;
    background-color: #f6f4f48f;
    border-radius: 2px;
    padding: 5px;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels ::v-deep .v-expansion-panel-content__wrap::-webkit-scrollbar {
  width: 4px;
  border-radius: 13px;
  margin-left: 5px;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels ::v-deep .v-expansion-panel-content__wrap::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 13px;
  margin-left: 5px;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels ::v-deep .v-expansion-panel-content__wrap::-webkit-scrollbar-thumb {
  background: #8888889f;
  border-radius: 13px;
  margin-left: 5px;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels ::v-deep .v-expansion-panel-content__wrap::-webkit-scrollbar-thumb:hover {
  background: #555555cb;
  border-radius: 13px;
  margin-left: 5px;
}
.custom-router-link {
    display: flex;
    align-items: center;
    padding: 1px 0 1px 5px !important;
    border-radius: 2px;
}
.custom-router-link a,
.v-expansion-panel .v-expansion-panel-header a,
.menu-drawer .header .flex-search .wrapper-add-menu .c-menu a,
.v-menu__content .add-menu-hover .c-menu a {
    color: #373737;
    height: 100%;
    width: 100%;
}
.custom-router-link:hover {
    background-color: #fff;
}
.custom-router-link .wrapper-router {
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: 4px 8px !important;
}
.custom-router-link.router-link-active {
    background-color: #fff;
}
.custom-router-link .wrapper-router .active {
    height: 17px;
    max-height: 17px;
    border-color: transparent;
    border-width: 1.5px;
    border-radius: 10px;
    flex: unset;
    margin-top: 2px;
    width: 0;
}
.custom-router-link.router-link-active .wrapper-router .active {
    border-color: #0066ff;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel .custom-router-link .v-btn,
.v-menu__content .custom-router-link .v-btn {
    padding: 4px !important;
    height: 20px !important;
}
.custom-router-link .v-icon.text--disabled {
    display: none;
}
.custom-router-link:hover .v-icon.text--disabled {
    display: block;
}
.menu-drawer .body .v-expansion-panels .flex-nav-expanded {
    display: flex;
    align-items: center;
    gap: .3rem;
}
.menu-drawer .body .v-expansion-panels .flex-nav {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 0;
}
.menu-drawer .body .v-expansion-panels .v-expansion-panel.not-expanded .v-expansion-panel-header ::v-deep .v-expansion-panel-header__icon,
.menu-drawer.mobile-menu-drawer .body .v-expansion-panels .v-expansion-panel.not-expanded .v-expansion-panel-header ::v-deep .v-expansion-panel-header__icon {
    display: none;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended {
    overflow: visible;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended ::v-deep .v-navigation-drawer__content {
    overflow: hidden;
}
.menu-drawer .body::-webkit-scrollbar {
    width: 0;
    border-radius: 13px;
    margin-left: 5px;
}
.menu-drawer .body::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 13px;
    margin-left: 5px;
}
.menu-drawer .body::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 13px;
    margin-left: 5px;
}
.menu-drawer .body::-webkit-scrollbar-thumb:hover {
    background: transparent;
    border-radius: 13px;
    margin-left: 5px;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panels .v-expansion-panel.v-expansion-panel--active.not-expanded ::v-deep .v-expansion-panel-content {
    position: absolute;
    top: 0;
    right: 74px;
    background-color: #fff;
    border-radius: 4px;
    width: 200px;
}
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-item-group.v-expansion-panels,
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panel,
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panel-header,
.menu-drawer.v-navigation-drawer.menu-drawer-not-expended .body .v-expansion-panel-content {
    transition: none !important;
}
/* v-menu */
.v-menu__content {
    min-width: unset !important;
    background-color: #fff;
    left: unset !important;
    right: 63px;
    z-index: 9 !important;
    width: 250px;
    max-height: 620px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
    border-radius: 4px;
}
.v-menu__content::-webkit-scrollbar-track {
  background-color: silver !important;
  border-radius: 13px;
  margin-left: 5px;
}
.v-menu__content::-webkit-scrollbar-thumb {
  background: silver !important;
  border-radius: 13px;
  margin-left: 5px;
}
.v-application--is-ltr .v-menu__content {
    left: 63px !important;
    right: unset;
}
.v-menu__content .wrapper-v-menu {
    background-color: #f6f4f48f;
    margin: 3px;
    width: 97%;
    border-radius: 2px;
    padding: 4px !important;
    display: flex;
    flex-direction: column;
    row-gap: .2rem;
}
::v-deep(.v-select.v-select--is-menu-active .v-input__icon--append .v-icon) {
    transform: none !important;
}
.menu-drawer ::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
min-height: 32px !important;
}

.menu-drawer ::v-deep .v-label.v-label {
font-size: 11px !important;
}
.theme--light.v-icon {
    color: inherit;
}
.v-menu__content::-webkit-scrollbar {
  width: 0 !important;
  border-radius: 13px;
  margin-left: 5px;
  background-color: silver !important;
}
::v-deep .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
    background-color: transparent;
}
/* @media (max-width: 960px) {
    .menu-drawer.desktop-menu-drawer {
        display: none;
    }
    .menu-drawer.mobile-menu-drawer {
        display: block;
    }
}
@media (min-width: 960px) {
    .menu-drawer.desktop-menu-drawer {
        display: block;
    }
    .menu-drawer.mobile-menu-drawer {
        display: none;
    }
} */
</style>
